import { useQuery } from '@tanstack/react-query';
import sessionStorageService from '../../../services/sessionStorage';
import rio from '../../../services/rio';
import drupalPubSubService from '../../../services/drupalPubSub/drupalPubSub';

const useGetStoresWithProductAvailableNearUser = ({
  ZIPCode,
  rioProductId,
}: { ZIPCode?: string; rioProductId?: string } = {}) => {
  const { publish } = drupalPubSubService;

  const query = useQuery({
    queryKey: ['getStoresWithProductAvailableNearUser', ZIPCode],
    queryFn: async () => {
      if (!ZIPCode || !rioProductId) {
        return {};
      }
      try {
        const response = await rio.getStoresWithProductAvailableNearZIPCode({
          ZIPCode,
          rioProductId,
        });
        sessionStorageService.setItem({
          itemName: 'storesWithProductAvailableNearUser',
          value: JSON.stringify(response),
        });
        publish({
          subscription: 'storesUpdated',
          parameters: {},
        });
        return response;
      } catch (error) {
        throw new Error(
          'Failed to fetch stores with product available near user',
        );
      }
    },
    enabled: !!ZIPCode && !!rioProductId,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useGetStoresWithProductAvailableNearUser;
